import { Skeleton } from 'antd';

import React from 'react';
const Loader = () => {
  return (
    <div style={{ margin: '0 auto' }}>
      <br />
      <br />
      <Skeleton.Image style={{ width: '220px', height: '200px' }} active />
      <br />
      <br />
      <Skeleton.Input style={{ width: '220px' }} active />
      <br />
      <br />
      <Skeleton.Input style={{ width: '220px' }} active />
      <br />
      <br />
      <Skeleton.Button style={{ width: '100px', marginRight: '30px' }} active />
      <Skeleton.Button style={{ width: '90px' }} active />
      <br />
      <br />
    </div>
  );
};
export default Loader;
